import React, {useState, useEffect} from 'react';

import {LoginState} from '~/src/utilities/constants/login';
import {getLoginState} from '~/src/utilities/helpers/login';

const LoginContext = React.createContext({
    isReady: false,
    isLoggedIn: false
});

const LoginProvider = ({children}) => {
    const [loginState, setLoginState] = useState(LoginState.PENDING);

    useEffect(() => {
        getLoginState().then(setLoginState);
    }, []);

    const value = {
        isReady: loginState !== LoginState.PENDING,
        isLoggedIn: loginState === LoginState.ACCOUNT
    };

    return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
};

const withLoginContext = (WrappedComponent) => ({context, ...props}) => (
    <LoginContext.Consumer>{(login) => <WrappedComponent context={{...context, login}} {...props} />}</LoginContext.Consumer>
);

export {LoginContext, withLoginContext};
export default LoginProvider;
